/* @flow */

export type State = ?{ message: string, status: number };
export type Action = { type: string, error: any, payload: any }

let RESET_MESSAGE = 'gdc/RESET_MESSAGE';
let SET_MESSAGE = 'gdc/SET_MESSAGE';
let initialState: State = null;

export default function reducer(state: State = initialState, action: Action): State {
  let { type, error } = action;
  if (type === RESET_MESSAGE) {
    return null;
  } else if (type === SET_MESSAGE) {
    return { message: action.payload.message, status: 200 };
  } else if (error) {
    return { message: action.payload.message || 'An API error has occured', status: action.payload.status || 500 };
  }
  return state;
}

// Resets the currently visible error message.
export function resetMessage(): Action {
  return {
    type: RESET_MESSAGE,
    error: null,
    payload: null
  };
}

export function setMessage(message: string): Action {
  return {
    type: SET_MESSAGE,
    error: null,
    payload: { message }
  };
}
